import React from 'react';

class TextRenderer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fullyVisible: this.props.fullyVisible || false
        }
    }

    prepareMarkup() {
        let textString = this.props.content || '';

        // Add links to possible urls
        const urlRegex = /(((https?:\/\/(www\.)?)|(www\.))[^\s]+)/g;
        textString = textString.replace(urlRegex, function(url) {
            const content = url;
            url = url.indexOf('http') > -1 ? url : 'http://' + url;
            // Strip trailing commas or dots
            url = url.replace(/(,$)|(\.$)/g, "");
            return '<a href="' + url + '">' + content + '</a>';
        });
        // Add linebreaks
        textString = textString.replace(/(?:\r\n|\r|\n)/g, '<br />');

        return textString;
    }

    render() {
        const className = 'user-content ' + ( this.state.fullyVisible ? 'open' : 'closed' );
        let moreOrLess;
        let moreOrLessText = this.state.fullyVisible ? 'Show less' : 'Show more';
        const markup = this.prepareMarkup();
        const sparta = markup.substring(0, 300);
        const re = new RegExp("<br />", "g");
        /* if length is greater than 300 or length is greater than 200 and text has more than 1 break row or
        * or if beginning of text has more than 4 break rows
        * */
        if (markup.length > 300 || (markup.length > 200 && (sparta.match(re) || []).length > 1) || (sparta.match(re) || []).length > 4){
            moreOrLess = <a className="readmore" onClick={this.toggleVisibility.bind(this)}>{moreOrLessText}</a>;
        }
        return (
            <div className="user-content-area">
                <div
                    className={className}
                    dangerouslySetInnerHTML={{__html: markup}}>
                </div>
                {moreOrLess}
            </div>
        );
    }

    toggleVisibility() {
        this.setState({fullyVisible:!this.state.fullyVisible});
    }
}

export default TextRenderer;



/** WEBPACK FOOTER **
 ** ./app/src/components/TextRenderer.js
 **/